import { facebookAppId } from 'server-data/login-signup';

// Asynchronously load Facebook SDK
const e = document.createElement('script');
e.type = 'text/javascript';
e.src = 'https://connect.facebook.net/en_US/sdk.js';
e.onerror = () => {
  window.fbAsyncInit(false);
};
const s = document.getElementsByTagName('script')[0];
s.parentNode.insertBefore(e, s);

// Initialise Facebook app
window.fbAsyncInit = (status = true) => {
  // Call load error if the FB SDK isn't loading.
  if (!status) {
    window.fbAsyncInitLoadError();
    return;
  }

  FB.init({
    appId: facebookAppId,
    version: 'v2.7',
    status: true,
    cookie: true,
    xfbml: true,
    oauth: true,
  });

  // This is legacy code. This function is located in @shared/facebook-connect
  // and it actually adds click event listeners on the FB login button and
  // other stuff.
  // It doesn't make sense to have a global here.
  // Shall we merge the 2 files? Or should we emit an event that we can listen
  // to from outside?
  if (typeof window.fbAsyncInit_pinky === 'function') {
    window.fbAsyncInit_pinky();
  }

  if (window.performance && window.performance.mark) {
    window.performance.mark('facebook_sdk_ready');
  }
};

// FIXME: Ideally we want the SDK to return a promise for when the SDK inits,
// or maybe a signal to say that the SDK has loaded?
export default window.FB;
